import { useQuery } from 'react-query'
import { request } from 'Features/auth/axios-client'

const fetchVolumeProjectionTableData = async (
  planId: string,
  workcenterId: string
) => {
  const data = await request({
    url: `plan/${planId}/workcentres/${workcenterId}/volume-projection-table`,
  })
  return data
}
export const useVolumeProjectionTableData = (
  planId: string,
  workcenterId: string,
  enabled = true
) => {
  return useQuery(
    ['volume-projection-tabl;e-data', planId, workcenterId],
    () => fetchVolumeProjectionTableData(planId, workcenterId),
    {
      select: ({ data }) => data?.data,
      refetchOnWindowFocus: false,
      enabled: enabled,
    }
  )
}
